import React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { GetAuth0Client } from '@switch/core';
import { useNavigate } from 'react-router-dom';

export const useBookingWidgetAuthentication = () => {
    const context = useBookingWidgetAuthenticationContext();

    return context;
};

export const BookingWidgetAuthenticationContext = createContext(undefined);

export const BookingWidgetAuthenticationContextProvider = ({ context, children }) => {
    const [requestToRestore, setRequestToRestore] = useState(null);

    const auth0 = GetAuth0Client();
    const navigate = useNavigate();

    useEffect(() => {
        const run = async () => {
            const params = new URLSearchParams(window.location.search)

            //handle auth-callback redirect
            if (params.get("code") && params.get("state")) {
                const res = await auth0.handleRedirectCallback();
                navigate(res?.appState?.returnTo ?? "/");
                setRequestToRestore(res?.appState?.request)
            }

            const platform = params.get("platform");
            const key = params.get("key");

            //handle logout redirect
            if (platform && key) {
                navigate(`/${platform}/${key}`)
            }
        }

        run();
    }, [])

    let contextData = {
        requestToRestore,
        ...context,
    };

    return (
        < BookingWidgetAuthenticationContext.Provider value={contextData} >
            {children}
        </BookingWidgetAuthenticationContext.Provider >
    );
};

export const useBookingWidgetAuthenticationContext = () => useContext(BookingWidgetAuthenticationContext);
